import React, { useState } from "react";
import location from "../../../assets/img/icons/location.svg";
import cal1 from "../../../assets/img/icons/calendar-2.svg";
import cal2 from "../../../assets/img/icons/calendar-tick.svg";
import user from "../../../assets/img/icons/user-edit.svg";
import search from "../../../assets/img/icons/search-white.svg";
import IconBox from "../../shared/IconBox";
import CityBox from "../../dropbox/CityBox";
import Datebox from "../../dropbox/Datebox";
import CountBox from "../../dropbox/CountBox";
import { createSearchParams, useNavigate } from "react-router-dom";
import CityModal from "./CityModal/CityModal";
import StateModal from "./CityModal/StateModal";
const Header = ({ dropbox, setDropbox }) => {
  const [selectedStartDay, setSelectedStartDay] = useState(null);
  const [selectedEndDay, setSelectedEndDay] = useState(null);
  const [chosenCity, setChoseCity] = useState([]);
  const [count, setCount] = useState(0);
  const [choseCityId, setchoseCityId] = useState([]); //city //start //end //count
  const [Stateinfo, setStateinfo] = useState([]);
  const [StateResults, setStateResults] = useState([]);
  const [ChoseState, setChoseState] = useState([]);
console.log("selectedStartDay",selectedStartDay?.format())
console.log(selectedEndDay)
  const navigate = useNavigate();
  const gotocat = () => {
    navigate({
      pathname: "/categories",
      search: createSearchParams({
        ledate:selectedEndDay ? selectedEndDay : null,
        endate: selectedStartDay ? selectedStartDay: null,
        cities:chosenCity ?  chosenCity.map(i => i.name).toString().replace(/,/g, "-") : null,
        state:ChoseState ? ChoseState[0].name : null,
        cap: count > 0 ? count :null
      }).toString()
    });
    console.log(
      `${selectedStartDay.year}-${selectedStartDay.month}-${selectedStartDay.day}`,
      selectedStartDay,
      chosenCity.map(i => i.slug).toString().replace(/,/g, "-"),
      count
    );
  };
  return (
    <div className="container-overflow">
      <div className="Header-box rounded[46px] overflow-hidden py-[64px] px-[117px]">
        <h1 className="text-[64px] text-[#fff] w-[55%] font-[900] ">
          هر جای ایران به کمک ما سفر کن و مثل خونه خودت احساس راحتی کن
        </h1>
        <h2 className="text-[35px] text-[#fff] w-[55%] font-[500] mt-[20px] ">
          از ویلای استخر دار تا بوم گردی جا با ما جوره :)
        </h2>
      </div>
      <div className="sub-headerbox flex justify-between items-center">
        <div className="relative">
          <div className="flex items-center ">
            <img src={location} className="ml-[12px]" alt="" />
            <button
              onClick={e => {
                e.stopPropagation();
                setDropbox("city");
              }}
              className="text-[25px] font-[500] "
            >
              مقصد شما
            </button>
          </div>
          <div className="text-[#797D82] text-[16px] mt-[20px]">
            شهر یا روستا مورد نظر خود را بنویسید
          </div>
          <div
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <StateModal
              setchoseCityId={setchoseCityId}
              choseCityId={choseCityId}
              setDropbox={setDropbox}
              setChoseCity={setChoseCity}
              dropbox={dropbox}
              chosenCity={chosenCity}
              Stateinfo={Stateinfo}
              setStateinfo={setStateinfo}
              StateResults={StateResults}
              setStateResults={setStateResults}
              setChoseState={setChoseState}
              ChoseState={ChoseState}
            />
          </div>
        </div>
        <div className="relative">
          <div
            className="flex items-center "
            onClick={e => {
              e.stopPropagation();
              setDropbox("start");
            }}
          >
            <img src={cal1} className="ml-[12px]" alt="" />
            <button
              onClick={e => {
                e.stopPropagation();
                setDropbox("start");
              }}
              className="text-[25px] font-[500] "
            >
              {" "}تاریخ ورود
            </button>
          </div>
          <div
            onClick={e => {
              e.stopPropagation();
              setDropbox("start");
            }}
            className="text-[#797D82] text-[16px] mt-[20px]"
          >
       {selectedStartDay
              ? <div>
                  {selectedStartDay.format()}
                </div>
              : "تاریخ ورود خود را وارد کنید"}
          </div>
          <Datebox
            setSelectedDay={setSelectedStartDay}
            SelectedDay={selectedStartDay}
            dropbox={dropbox}
            className={`datebox-start ${dropbox === "start"
              ? "box-show"
              : "box-hidden"}`}
          />
        </div>
        <div className="relative">
          <div
            className="flex items-center "
            onClick={e => {
              e.stopPropagation();
              setDropbox("Start");
            }}
          >
            <img src={cal2} className="ml-[12px]" alt="" />
            <button
              className="text-[25px] font-[500] "
              onClick={e => {
                e.stopPropagation();
                setDropbox("end");
              }}
            >
              تاریخ خروج
            </button>
          </div>
          <div
            onClick={e => {
              e.stopPropagation();
              setDropbox("end");
            }}
            className="text-[#797D82] text-[16px] mt-[20px]"
          >
          {selectedEndDay
              ? <div>
                  {selectedEndDay.format()}
                </div>
              : "  تاریخ خروج خود وارد کنید"} 
          </div>
          <Datebox
            setSelectedDay={setSelectedEndDay}
            SelectedDay={selectedEndDay}
            dropbox={dropbox}
            className={`datebox-end ${dropbox === "end"
              ? "box-show"
              : "box-hidden"}`}
          />
        </div>
        <div className="relative">
          <div className="flex items-center ">
            <img src={user} className="ml-[12px]" alt="" />
            <button
              onClick={e => {
                e.stopPropagation();
                setDropbox("count");
              }}
              className="text-[25px] font-[500] "
            >
              تعداد نفرات
            </button>
          </div>
          <div
            onClick={e => {
              e.stopPropagation();
              setDropbox("count");
            }}
            className="text-[#797D82] text-[16px] mt-[20px]"
          >
            {count === 0
              ? "تعداد نفرات همسفران خود را وارد کنید"
              : <div>
               {count} نفر
                </div>}
          </div>
          <CountBox
            count={count}
            setCount={setCount}
            className={`datebox-end ${dropbox === "count"
              ? "box-show"
              : "box-hidden"}`}
          />
        </div>
        <IconBox onClick={() => gotocat()}>
          <img src={search} />
        </IconBox>
      </div>
    </div>
  );
};

export default Header;
